import { create } from "zustand";

export const useDataUserStore = create((set) => ({
  misActas: [],

  setMisActas: (actas) => {
    set({ misActas: actas });
  },
}));
